// extracted by mini-css-extract-plugin
export default {"tableHeader":"LosListe_tableHeader__IaWlV","activeTab":"LosListe_activeTab__tyvGt","inactiveTab":"LosListe_inactiveTab__RwqXi","inputs":"LosListe_inputs__wmnAF"};